<div class="panel-group be-collapse-box" id="accordion" role="tablist" aria-multiselectable="true">
    <div class="panel panel-default">
        <div class="panel-heading" role="tab" id="headingOne">
            <div class="panel-title">
                <a role="button" data-toggle="collapse" data-parent="#accordion" href="#bov" aria-expanded="true" aria-controls="bov">
                    <h2 class="mainhead d-flex">
                        <span class="text mr-auto">BOV</span>
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </h2>
                </a>
            </div>
        </div>
        <div id="bov" class="panel-collapse collapse in" role="tabpanel" aria-labelledby="headingOne">
            <div class="be-tab-03 margin-bottom-30">
                <ul class="nav nav-tabs d-flex">
                    <li class="nav-item">
                        <a class="nav-item" [ngClass]="bovTabs.InformationUpload == tabId? 'active' : '' " (click)="onTabClick(bovTabs.InformationUpload)">
                            <span><i class="icon-logout"></i></span>
                            Information Upload
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item" [ngClass]="bovTabs.PriceAnalysis == tabId? 'active' : '' " (click)="onTabClick(bovTabs.PriceAnalysis)">
                            <span><i class="icon-analytics"></i> </span>
                            Pricing Analysis
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-item" [ngClass]="bovTabs.Review == tabId? 'active' : '' " (click)="onTabClick(bovTabs.Review)">
                            <span><i class="icon-deal"></i></span>
                            Broker Opinion of Value
                        </a>
                    </li>
                </ul>
            </div>
            <div class="panel-body">
                <div class="tab-content padding0">
                    <ng-container *ngIf="bovTabs.InformationUpload == tabId">
                        <app-bovinformation-upload [propertyId]="propertyId"></app-bovinformation-upload>
                    </ng-container>
                    <ng-container *ngIf="bovTabs.PriceAnalysis == tabId">
                        <app-bov-price-analysis [propertyId]="propertyId"></app-bov-price-analysis>
                    </ng-container>
                    <ng-container *ngIf="bovTabs.Review == tabId">
                        <app-bov-ready-for-review [propertyId]="propertyId"></app-bov-ready-for-review>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>




